export default class PDAModel {
  constructor(graphElements) {
    this.elements = graphElements;
  }
}
